import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceInsightsData', [
    'cachedDeviceEventsSortedCycleAsArrayObjects',
    'cachedDeviceInsightsWithFiltersSortedStatusFormattedAsArrayObjects',
    'cachedDeviceInsightsWithFiltersSortedActivityFormattedAsArrayObjects',
    'cachedDeviceInsightsWithFiltersSortedByHourFormattedAsArray',
    'distinctSortedObjectOfStatusNames',
    'distinctSortedArrayOfStatusNames',
    'distinctArrayOfShiftPatternNames',
  ]),
}

export const Methods = mapActions('deviceInsightsData', [])
